function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  .tag {\n    padding: 2px 5px;\n    margin: 1px 0 2px;\n    border-radius: 4px;\n    font-size: 10px;\n    background-color: ", ";\n    color: rgb(255, 255, 255);\n    text-transform: capitalize;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import Icon from '../../atoms/Icon';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
var MenuIconWrapper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.status.errorColorActive;
});

var MenuIcon = function MenuIcon(_ref2) {
  var name = _ref2.name,
      tag = _ref2.tag,
      rest = _objectWithoutPropertiesLoose(_ref2, ["name", "tag"]);

  return /*#__PURE__*/React.createElement(MenuIconWrapper, rest, tag ? /*#__PURE__*/React.createElement("span", {
    className: "tag"
  }, tag) : null, /*#__PURE__*/React.createElement(Icon, {
    path: name
  }));
};

MenuIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  tag: PropTypes.string
} : {};
MenuIcon.defaultProps = {
  theme: defaultTheme,
  tag: null
};
export default MenuIcon;